module.exports = __webpack_public_path__ + "img/rank_lieutenant.7186f228.svg";